<template>
  <div class="mentIndex">
    <div class="home_con">
       <div class="moment"><Menthu /></div>
      <div class="mentCon">
        <div class="ment_title">业务信息交换规范</div>
        <p>1.范围</p>
        <span
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本部分规定了电动汽车充换电业务信息服务交换的方法，包括业务信息交换的接口流程、接口功能和接口协议。<br />
             
          &nbsp;&nbsp;本部分适用于不同运营商服务平台之间的充换电服务信息交换，以及电动汽车充换电服务平台与第三方服务及管理平台之间的信息交换。</span
        >
        <p>2.规范性引用文件</p>
        <span
          >下列文件对于本文件的应用是必不可少的。凡是注日期的引用文件，仅注日期的版本适用于本文件。凡是不注日期的引用文件，其最新版本（包括所有的修改单）适用于本文件。<br /><br />GB/T
          2261.1-2003 个人基本信息分类与代码<br /><br />GB/T 2659-2000
          世界各国和地区名称代码<br /><br />GB/T 2260-2002
          中华人民共和国行政区划代码<br /><br />GB/T 7408-2005
          数据元和交换格式信息交换日期和时间表示法<br /><br />GB 11714-1997
          全国组织机构代码编制规则<br /><br />GB/T 18391.1-2002
          信息技术数据元的规范与标准化 第1部分：数据元的规范与标准化框架<br /><br />GB/T
          18487.1-2015 电动汽车传导充电系统 第1部分：通用要求<br /><br />GB/Z
          19027-2005 统计技术指南<br /><br />GB/T 19596-2004 电动汽车术语<br /><br />GB/T
          27930-2015 电动汽车非车载传导式充电机与电池管理系统之间的通信协议<br /><br />GB/T
          29317-2012 电动汽车充换电设施术语<br /><br />GB/T 31286-2014
          全国组织机构代码与名称<br /><br />NB/T 33001-2010
          电动汽车非车载传导式充电机技术条件<br /><br />NB/T 33002-2010
          电动汽车交流充电桩技术条件<br /><br />NB/T 33003-2010
          电动汽车非车载充电机监控单元与电池管理系统通信协议<br /><br />NB/T
          33007-2013 电动汽车充电站/电池更换站监控系统与充换电设施通信协议</span
        >
        <p>3.术语和定义</p>
        <span
          > GB/T 19596、GB/T 29317、GB/Z
          19027-2005以及《电动汽车充换电服务信息交换
          第1部分：总则》届定的以及下列术语和定义适用于本文件。</span
        >
        <small>3.1</small>
        <span
          >客户侧发起业务交互 EV driver’s service operator initiated
          interaction<br /><br />用户采用手机APP等方式，由客户运营商发起电动汽车额服务充换电服务信息交换的过程。</span
        >
        <small>3.2</small>
        <span
          >设备侧发起业务交互 EVI service operator initiated interaction<br /><br />用户采用刷卡等方式，由基础设施归属运营商发起电动汽车额服务充换电服务信息交换的过程。</span
        >
        <p>4.业务信息交换流程</p>
        <small> 4.1　客户侧发起业务交互流程</small>
        <span>
          客户侧发起业务交互由用户发起，客户归属运营商的电动汽车充换电服务平台向基础设施运营商发起信息交换业务，实现此业务的7项业务交互流程如图1所示，具体业务时序参见附录A
          图A.1。</span
        >
        <img class="pc_img" src="@/assets/menthu/3/1.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/1.png" alt="" />
        <span
          >具体业务功能包括设备认证服务、业务策略服务（可选）、启动充电服务、充电监控服务（可选）、充电停止服务（可选）、充电订单服务、订单对账服务。</span
        >
        <small>4.2　设备侧发起业务交互流程</small>
        <span
          >客户侧发起业务交互由用户发起，基础设施运营商的电动汽车充换电服务平台向客户归属运营商发起信息交换业务，实现此业务的7项业务交互流程如图2所示，具体业务时序参见附录A
          图A.2。</span
        >
        <img class="pc_img" src="@/assets/menthu/3/2.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/2.png" alt="" />
        <span
          >具体业务功能包括用户认证服务、业务策略服务（可选）、充电监控服务（可选）、充电停止服务（可选）、充电订单服务、订单对账服务。</span
        >
        <p>5.业务信息交换功能</p>
        <small> 5.1　业务信息交换功能分类</small>
        <span
          >业务信息交换规范共设计7个业务功能，分别是：<br /><br />设备认证服务<br /><br />业务策略服务<br /><br />启动充电服务<br /><br />充电监控服务<br /><br />充电停止服务<br /><br />充电订单服务<br /><br />订单对账服务</span
        >
        <small>5.2　设备认证服务</small>
        <img class="pc_img" src="@/assets/menthu/3/3.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/3.png" alt="" />
        <span
          >设备认证服务用于客户归属运营商向基础设施运营商查询电动汽车充电基础设施的可用状态，业务流程参见图3。主要包含请求设备认证接口。</span
        >

        <small> 5.3　业务策略服务（可选）</small>
        <img class="pc_img" src="@/assets/menthu/3/4.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/4.png" alt="" />
        <span
          >业务策略服务用于客户归属运营商向基础设施运营商查询充电基础设施的计费信息或基础设施运营商向客户归属运营商查询用户计费信息，业务流程参见图4。主要包含查询业务策略接口。</span
        >
        <small> 5.4　启动充电服务</small>
        <img class="pc_img" src="@/assets/menthu/3/5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/5.png" alt="" />
        <span>
          启动充电服务用于客户归属运营商服务平台请求启动充电，基础设施运营商服务平台完成启动充电后推送启动充电结果，业务流程参见图5。主要包含请求启动充电接口和推送启动充电结果接口。</span
        >
        <small>5.5　充电监控服务（可选）</small>
        <span
          >充电监控服务用于电动汽车充电基础设施变化状态的查询或推送，基础设施运营商服务平台推送业务流程见图6，客户归属运营商服务平台查询业务流程见图7。主要包含推送充电状态接口和查询充电状态接口。</span
        >
        <img class="pc_img" src="@/assets/menthu/3/6.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/6.png" alt="" />
        <small>5.6　充电停止服务（可选）</small>
        <img class="pc_img" src="@/assets/menthu/3/7.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/7.png" alt="" />
        <span
          >充电停止服务用于客户归属运营商服务平台请求停止充电，基础设施运营商服务平台停止充电后推送停止充电结果，业务流程参见图8。主要包含请求停止充电接口和推送停止充电结果接口。</span
        >

        <small> 5.7　充电订单服务</small>
        <img class="pc_img" src="@/assets/menthu/3/8.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/8.png" alt="" />
        <span
          >充电订单服务用于基础设施运营商服务平台向客户归属运营商服务平台推送充电订单信息，业务流程参见图9。主要包含推送充电订单信息接口。</span
        >
        <small> 5.8　订单对账服务</small>
        <img class="pc_img" src="@/assets/menthu/3/9.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/9.png" alt="" />
        <span
          >订单对账服务用于基础设施运营商服务平台向客户归属运营商服务平台推送订单对账信息，业务流程参见图10。主要包含推送订单对账结果信息接口。</span
        >
        <p>6.业务信息交换接口协议</p>
        <small>6.1　概述</small>
        <span
          >业务信息交换共分为10个接口，分别为：<br /><br />请求设备认证<br /><br />查询业务策略信息结果<br /><br />请求启动充电<br /><br />推送启动充电结果<br /><br />查询充电状态<br /><br />推送充电状态<br /><br />请求停止充电<br /><br />推送停止充电结果<br /><br />推送充电订单信息<br /><br />推送订单对账结果信息</span
        >

        <small>6.2　请求设备认证</small>
        <small>6.2.1　概述</small>
        <span>此接口用于客户归属运营商请求充电基础设施的认证信息。</span>
        <small>6.2.2　接口定义</small>
        <span>
          接口名称：query_equip_auth<br /><br />接口使用方法：由基础设施运营商服务平台实现此接口，客户归属运营商服务平台方调用。</span
        >
        <small>6.2.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/10.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/10.png" alt="" />

        <small>6.2.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/11.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/11.png" alt="" />
        <small>6.2.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/3/6.2.5.png" alt="" />
        <!-- <img class="pc_img" src="@/assets/menthu/5/6.2.5.png" alt="" /> -->
        <small>6.3　查询业务策略信息结果</small>

        <small>6.3.1　概述</small>
        <span
          >此接口用于设备归属运营商（客户归属运营商）向客户归属运营商（设备归属运营商）查询充电桩业务策略信息。</span
        >
        <small>6.3.2　接口定义</small>
        <span>
          接口名称：query_equip_business_policy        
          <br /><br />接口使用方法：由客户归属运营商(设备归属运营商)平台实现此接口，设备归属运营商(客户归属运营商)平台方调用。</span
        >

        <small>6.3.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/12.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/12.png" alt="" />
        <small>6.3.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/13.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/13.png" alt="" />

        <small>体（policyInfo）</small>
        <img class="pc_img" src="@/assets/menthu/3/14.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/14.png" alt="" />

        <small>6.3.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.3.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.3.5.png" alt="" />
        <small>6.4　请求启动充电</small>
        <small>6.4.1　概述</small>
        <span
          >此接口用于客户归属运营商请求设备归属运营商启动充电信息,充电模式为充满为止。</span
        >
        <small>6.4.2　接口定义</small>
        <span>
          接口名称：query_start_charge        <br /><br />接口使用方法：由基础设施运营商服务平台实现此接口，客户归属运营商服务平台方调用。</span
        >
        <small>6.4.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/15.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/15.png" alt="" />
        <small>6.4.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/16.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/16.png" alt="" />
        <small> 6.4.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.4.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.4.5.png" alt="" />
        <small>6.4　请求启动充电</small>
        <small>6.5　推送启动充电结果</small>
        <small>6.5.1　概述</small>
        <span
          >此接口用于设备归属运营商向客户归属运营商推送启动充电结果信息。</span
        >

        <small> 6.5.2　接口定义</small>
        <span
          >接口名称：notification_start_charge_result        
          <br /><br />接口使用方法：由客户归属运营商服务平台实现此接口，基础设施运营商服务平台方调用。</span
        >
        <small></small>
        <small>6.5.3　输入参数</small>
        <img class="pc_img"  src="@/assets/menthu/3/17.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/17.png" alt="" />
        <small>6.5.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/18.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/18.png" alt="" />
        <img class="pc_img" style="margin-top: 0px" src="@/assets/menthu/3/19.png" alt="" />
         <img class="mo_img" style="margin-top: 0px" src="@/assets/mohu/3/19.png" alt="" />
        <small>6.5.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.6.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.6.5.png" alt="" />
        <small>6.6　查询充电状态</small>
        <small>6.6.1　概述</small>
        <span
          >此接口用于客户归属运营商请求设备归属运营商充电设备的状态信息。</span
        >
        <small>6.6.2　接口定义</small>
        <span
          >接口名称：query_equip_charge_status<br /><br />接口使用方法：由基础设施运营商服务平台实现此接口，客户归属运营商服务平台方调用。</span
        >
        <small>6.6.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/20.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/20.png" alt="" />
        <small>6.6.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/21.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/21.png" alt="" />
        <small>充电明细信息体（ChargeDetails）</small>
        <img  class="pc_img"  src="@/assets/menthu/3/22.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/22.png" alt="" />

        <small>6.6.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.6.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.6.5.png" alt="" />
        <small>6.7　推送充电状态</small>
        <small>6.7.1　概述</small>
        <span>
          此接口用于设备归属运营商向客户归属运营商推送充电设备的充电状态。</span
        >
        <small>6.7.2　接口定义</small>
        <span>
          接口名称：notification_equip_charge_status<br /><br />接口使用方法：由客户归属运营商服务平台实现此接口，基础设施运营商服务平台方调用。</span
        >
        <small>6.7.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/23.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/23.png" alt="" />
        <small>6.7.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/24.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/24.png" alt="" />
        <small>6.7.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.7.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.7.5.png" alt="" />

        <small>6.8　请求停止充电</small>
        <small>6.8.1　概述</small>
        <span
          >此接口用于客户归属运营商请求设备归属运营商设备停止充电信息。</span
        >
        <small>6.8.2　接口定义</small>
        <span>
          接口名称：query_stop_charge<br /><br />接口使用方法：由基础设施运营商服务平台实现此接口，客户归属运营商服务平台方调用。</span
        >
        <small>6.8.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/25.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/25.png" alt="" />
        <small>6.8.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/26.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/26.png" alt="" />

        <small>6.8.5 示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.8.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.8.5.png" alt="" />
        <small> 6.9　推送停止充电结果</small>
        <small>6.9.1　概述</small>
        <span
          > 
          此接口用于设备归属运营商向客户归属运营商推送停止充电结果信息。</span
        >
        <small> 6.9.2　接口定义</small>
        <span>
          接口名称：notification_stop_charge_result<br /><br />接口使用方法：由客户归属运营商服务平台实现此接口，基础设施运营商服务平台方调用。</span
        >
        <small>6.9.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/27.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/27.png" alt="" />
        <small>  6.9.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/28.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/28.png" alt="" />
        <small>6.9.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.9.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.9.5.png" alt="" />
        <small>6.10　推送充电订单信息</small>
        <small>6.10.1　概述</small>
        <span>此接口用于设备归属运营商向客户归属运营商推送充电订单信息。</span>
        <small>6.10.2　接口定义</small>
        <span>
          接口名称：notification_charge_order_info<br /><br />接口使用方法：由客户归属运营商服务平台实现此接口，基础设施运营商服务平台方调用。</span
        >
        <small> 6.10.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/29.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/29.png" alt="" />
        <img class="pc_img" src="@/assets/menthu/3/30.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/30.png" alt="" />
        <small>6.10.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/31.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/31.png" alt="" />
        <small>6.10.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.10.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.10.5.png" alt="" />

        <small> 6.11　推送订单对账结果信息</small>
        <small>6.11.1　概述</small>
        <span
          >此接口用于设备归属运营商向客户归属运营商推送充电订单对账信息。</span
        >
        <small> 6.11.2　接口定义</small>
        <span>
          接口名称：check_charge_orders）<br /><br />接口使用方法：由客户归属运营商服务平台实现此接口，基础设施运营商服务平台方调用。</span
        >
        <small>6.11.3　输入参数</small>
        <img class="pc_img" src="@/assets/menthu/3/32.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/32.png" alt="" />
        <small>单项订单对账信息体（ChargeOrder）</small>
        <img class="pc_img" src="@/assets/menthu/3/33.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/33.png" alt="" />
        <small>6.11.4　返回值</small>
        <img class="pc_img" src="@/assets/menthu/3/34.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/34.png" alt="" />
        <small>单项争议交易信息体（ChargeOrder）</small>
        <img class="pc_img" src="@/assets/menthu/3/35.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/35.png" alt="" />
        <small>6.11.5　示例</small>
        <img class="pc_img" src="@/assets/menthu/5/3-6.11.5.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/5/3-6.11.5.png" alt="" />
        <p>附　录　A</p>
        <span
          >（资料性附录）<br /><br />电动汽车充换电业务信息交换接口(Iserv)流程时序图</span
        >
        <small>A.1　用户侧发起充电流程时序图</small>
        <img class="pc_img" src="@/assets/menthu/3/36.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/36.png" alt="" />
        <small>A.2　设备侧发起充电流程时序图</small>
        <img class="pc_img" src="@/assets/menthu/3/37.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/3/37.png" alt="" />
        <small></small>
        <span></span>
        <small></small>
        <span></span>
      </div>
    </div>
  </div>
</template>


<script>
import Menthu from "@/components/menthu";
export default {
  components: {
    Menthu,
  },
};
</script>

<style scoped>
.home_con {
  display: flex;
  text-align: left;
}
small {
  font-family: Helvetica;
  margin-top: 24px;
}
.mentCon{
   margin-top:10px;
}
.mentCon .text_hh {
  margin-top: 12px;
  display: flex;
  font-size: 12px;
  font-family: Helvetica;
  color: #191c27;
  line-height: 18px;
}
.mentCon img{
  margin-top:0px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentk.vue